import FilterSidebar from '@components/FilterSidebar/FilterSidebar';
import React, { FunctionComponent } from 'react';

import css from './TribesRoute.module.less';
import TribesFilters from '@components/TribesFilters';
import { TribesEditModal, TribesList } from '@pages/TribesPage';
import { useStore } from 'effector-react';
import modals, { IModalsState } from '@stores/modals';
import useQueryFilters from '@hooks/useQueryFilters';
import { parseTribesFilters } from '@helpers/tribesFilters';

const TribesRoute: FunctionComponent<unknown> = () => {
  const { filters, setFilters } = useQueryFilters(parseTribesFilters);
  const {
    visibleState: { tribes: visible },
    data,
  } = useStore<IModalsState<any>>(modals);
  return (
    <div className={css.root}>
      <FilterSidebar className={css.selector}>
        <TribesFilters
          filters={filters}
          setFilters={setFilters}
        />
      </FilterSidebar>
      <div className={css.list}>
        <TribesList filters={filters} />
      </div>
      {visible ? <TribesEditModal data={data} /> : null}
    </div>
  );
};

export default TribesRoute;
